export function format<T extends {}>(): (params: T) => string {
  return (params: T) => '';
}

export function text(): string {
  return '';
}
